var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es318.js.map
